/*
 * petngo-hero.js
 * -------------------------------------------------------------------------
 * Vanilla controller for the PetNGo home hero (sections/petngo-hero.liquid).
 * Mirrors the Hydrogen Hero.tsx behaviour: dot + arrow navigation, looping
 * autoplay that honours prefers-reduced-motion, and re-init on Theme Editor
 * section load. No dependencies, idempotent, one controller per [data-pn-hero].
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  function initHero(root) {
    if (!root || root.__pnHeroInit) return;
    root.__pnHeroInit = true;

    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-pn-hero-slide]')
    );
    var dots = Array.prototype.slice.call(
      root.querySelectorAll('[data-pn-hero-dot]')
    );
    if (slides.length <= 1) return;

    var index = 0;
    var timer = null;
    var autoplay = root.getAttribute('data-pn-hero-autoplay') === 'true' && !REDUCED;
    var interval = parseInt(root.getAttribute('data-pn-hero-interval'), 10);
    if (isNaN(interval) || interval < 2000) interval = 5000;

    function render() {
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        // Keep tab order in sync: only the active slide's focusables are reachable.
        var focusables = slide.matches('a[href]')
          ? [slide]
          : Array.prototype.slice.call(slide.querySelectorAll('a[href], button'));
        focusables.forEach(function (el) {
          el.setAttribute('tabindex', active ? '0' : '-1');
        });
      });
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function goTo(next) {
      var total = slides.length;
      index = ((next % total) + total) % total;
      render();
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = window.setInterval(function () {
        goTo(index + 1);
      }, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var target = parseInt(dot.getAttribute('data-pn-hero-dot'), 10);
        if (!isNaN(target)) {
          goTo(target);
          start();
        }
      });
    });

    var prev = root.querySelector('[data-pn-hero-prev]');
    var next = root.querySelector('[data-pn-hero-next]');
    if (prev) {
      prev.addEventListener('click', function () {
        goTo(index - 1);
        start();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        goTo(index + 1);
        start();
      });
    }

    // Touch swipe (mobile): a horizontal drag changes slide. Passive listeners
    // so vertical page scroll is never blocked; we only act when the gesture is
    // clearly horizontal and past a threshold. Swipe left → next, right → prev.
    var swipeX = 0;
    var swipeY = 0;
    var swiping = false;
    root.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length !== 1) return;
        swipeX = e.touches[0].clientX;
        swipeY = e.touches[0].clientY;
        swiping = true;
        stop();
      },
      { passive: true }
    );
    root.addEventListener(
      'touchend',
      function (e) {
        if (!swiping) return;
        swiping = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - swipeX;
        var dy = t.clientY - swipeY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          goTo(dx < 0 ? index + 1 : index - 1);
        }
        start();
      },
      { passive: true }
    );
    root.addEventListener(
      'touchcancel',
      function () {
        swiping = false;
        start();
      },
      { passive: true }
    );

    // Pause on hover / focus so the user can read or tab through.
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    render();
    start();
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-pn-hero]');
    Array.prototype.forEach.call(nodes, initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme Editor: re-init when a section is added/reloaded.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
